import {ActionReducerMapBuilder} from '@reduxjs/toolkit';
import {TimeslotsState} from '../stateTypes';
import {actions} from '../actions';

export const extendWithDetailsReducers = (builder: ActionReducerMapBuilder<TimeslotsState>) => {
  builder
    .addCase(actions.loadReservationDetails.pending, (state, action) => {
      state.pendingDetailRequests.push(action.meta.arg.workspaceReservation.id);
    })
    .addCase(actions.loadReservationDetails.fulfilled, (state, action) => {
      state.pendingDetailRequests = state.pendingDetailRequests.filter(
        (id) => id !== action.meta.arg.workspaceReservation.id,
      );
    })
    .addCase(actions.loadReservationDetails.rejected, (state, action) => {
      state.pendingDetailRequests = state.pendingDetailRequests.filter(
        (id) => id !== action.meta.arg.workspaceReservation.id,
      );
    });
};
